import { createModule, getModuleByDomNode } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Cookies from 'js-cookie';
import * as Overlays from '@project/shared/utils/overlays/js/overlays';

const classes = {
	buttonClose: 'js-m-survey__close'
};

@createModule('Survey')
/**
 * Survey module implementation.
 *
 * @author Ellen Xia
 */
export class Survey extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		const $buttonClose = this.$ctx.find(`.${classes.buttonClose}`);
		$buttonClose.on('click', this.onCloseClick.bind(this));

		this.initSurvey();

		resolve();
	}

	stop() { }

	_showSurvey() {
		$(this._ctx).addClass('state-m-survey--visible ');
		$('html').addClass('no-scrolling--without-scrollbar');
	}

	_hideSurvey() {
		$(this._ctx).removeClass('state-m-survey--visible ');
		$('html').removeClass('no-scrolling--without-scrollbar');
		//$(this.$ctx).empty();
	}

	initSurvey() {
		let showsurvey = false;
		if (location.search && location.search.indexOf('showsurvey=true') > -1) {
			showsurvey = true;
		}

		let waitingTime = parseInt($(this._ctx).attr("data-waitTime"));
		if (isNaN(waitingTime)) {
			waitingTime = 10;
		}

		if (showsurvey || !this.cookieSurveyRead()) {
			Overlays.ShowOverlay(
				() => this._showSurvey(),
				waitingTime * 1000
			);
		}
	}

	onCloseClick() {
		this.setSurveyRead();

		Overlays.CloseOverlay(
			() => this._hideSurvey()
		);
	}

	/**
	 * returns if cookie notice was already read (cookielifetime 1 year // "not read" after 2 month, if not all accepted)
	 *
	 * @returns {boolean} was read
	 */
	private cookieSurveyRead(): boolean {
		const readCookie = Cookies.get('survey_read');
		if (readCookie) {
			return true;
		}
		return false;
	}
	/**
	 * Saves read status of survey, in not already set
	 *
	 * @param {boolean} force  defines that cookie should be updated even if already set
	 * @returns {void}
	 */
	private setSurveyRead(): void {
		const readCookie = Cookies.get('survey_read');
		if (readCookie) {
			Cookies.remove('survey_read');
		}
		Cookies.set('survey_read', '1', { expires: 60 });
	}
}
